import HoldersTable from './HoldersTable'
import './HoldersStatsItem.css'

export default function HoldersStatsItem({ id, heading, state, show }) {
    const isLoading = !state
    return (
        <div className="card">
            <div className="card-header" id={`heading-${id}`}>
                <h2 className="mb-0">
                    <button
                        className="btn btn-link btn-block text-left"
                        type="button"
                        data-toggle="collapse"
                        data-target={`#collapse-${id}`}
                        aria-expanded="true"
                        aria-controls={`collapse-${id}`}
                    >
                        {heading}
                    </button>
                </h2>
            </div>

            <div
                id={`collapse-${id}`}
                className={`collapse${show ? ' show' : ''}`}
                aria-labelledby={`heading-${id}`}
                data-parent="#holdersStats"
            >
                <div className="card-body">
                    {isLoading ? (
                        <p>Loading ...</p>
                    ) : (
                        <>
                            {state?.success ? (
                                <HoldersTable
                                    data={state.data}
                                    totalCount={state.count}
                                />
                            ) : (
                                <p>There was an error getting the stats :(</p>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}
